import { createSelector } from "@reduxjs/toolkit";

import { nodeDesignsStateSelector } from "../managed/index.ts";

export const nodeDesignsByIdSelector = createSelector(
  nodeDesignsStateSelector,
  (nodeDesigns) => nodeDesigns.designsById,
);

export const nodeDesignsSlotsByParentIdSelector = createSelector(
  nodeDesignsStateSelector,
  (nodeDesigns) => nodeDesigns.slotsByParentId,
);

export const nodeDesignsParentIdByChildIdSelector = createSelector(
  nodeDesignsStateSelector,
  (nodeDesigns) => nodeDesigns.parentIdByChildId,
);
